import React                              from "react";
import { graphql }                        from "gatsby";
import Breakpoint                         from "react-socks";
import { Box, Button, Center }            from "@chakra-ui/react";
import { GiDiamondRing, GiWatch, GiShop } from "react-icons/gi";

import CallToAction              from "@interness/theme-sonora/src/components/CallToAction/CallToAction";
import Heading                   from "@interness/web-core/src/components/text/Heading/Heading";
import Spacer                    from "@interness/web-core/src/components/structure/Spacer/Spacer";
import Wrapper                   from "@interness/web-core/src/components/structure/Wrapper/Wrapper";
import BrandsDisplay             from "@interness/theme-sonora/src/components/Display/BrandsDisplay";
import SEO                       from "@interness/web-core/src/components/modules/SEO/SEO";
import Link                      from "@interness/web-core/src/components/elements/Link/Link";
import LiveAnnouncements
                                 from "@interness/web-core/src/components/structure/LiveAnnouncements/LiveAnnouncements";
import RandomShopItems           from "@interness/ecommerce-addon/src/components/RandomShopItems/RandomShopItems";
import Mounted                   from "@interness/web-core/src/components/structure/Mounted/Mounted";
import RandomSquareGalleryImages from "@interness/brands-addon/src/components/media/RandomSquareGalleryImages";
import RandomBrandHeaderImages
                                 from "@interness/brands-addon/src/components/media/RandomBrandHeaderImages/RandomBrandHeaderImages";

function IndexPage({ data }) {
  return (
    <>
      <SEO title={"Startseite"} />
      <Mounted>
        <Breakpoint small down>
          <RandomSquareGalleryImages />
        </Breakpoint>
        <Breakpoint medium up>
          <RandomBrandHeaderImages />
        </Breakpoint>
      </Mounted>
      <Wrapper>
        <Spacer />
        <LiveAnnouncements />
        <section>
          <Heading subtitle={"Herzlich Willkommen"} icon={<GiDiamondRing />}>
            Juwelier Hohage
          </Heading>
          <Box>
            <p>
              Seien Sie herzlich willkommen bei Juwelier Hohage in Lüdenscheid,
              im Herzen der Stadt des Lichts.
            </p>
            <p>
              Auf traditionelle Weise trägt Juwelier Hohage seit vielen Jahren
              in Lüdenscheid dazu bei, Ihre Wünsche und Träume bei Uhren,
              Schmuck und exklusive Trauringe und Eheringe zu erfüllen.
            </p>
            <p>
              Wir freuen uns auf Ihren Besuch in unserem modernen Geschäft in
              der Wilhelmstr. 34 in Lüdenscheid, wo wir uns in entspannter
              Atmosphäre ausgiebig Zeit für Ihre Wünsche nehmen möchten.
              Kompetente und persönliche Beratung rund um die Themen Schmuck,
              Uhren und bei Trauringen und Eheringen ist für das Team von
              Juwelier Hohage selbstverständlich.
            </p>
            <p>
              Wir laden Sie herzlich ein, bei Ihrem Besuch in unserem Geschäft
              Ihre Lieblingsstücke auszuwählen, anzuprobieren und zu
              begutachten. In unserem fein ausgewählten Sortiment finden Sie
              sowohl erlesenen als auch top aktuellen Schmuck, moderne und
              klassische Uhren, traumhafte Trauringe und Eheringe sowie
              extravagante Accessoires.
            </p>
            <p>
              Ihre Lieblinge sind bei unserem Uhrmachermeister in unserer
              Meisterwerkstatt gut aufgeboben. Hier bekommen Sie unseren
              perfekten Service.
            </p>
            <p>
              BIS BALD IN LÜDENSCHEID
              <br />
              IHRE FAMILIE MARKES
            </p>
          </Box>
        </section>
        <Spacer />
        <section>
          <Heading tag={"h2"} icon={<GiShop />}>
            Aktuelle Kollektionen
          </Heading>
          <Spacer height={40} />
          <BrandsDisplay />
        </section>
        <Spacer />
        <section>
          <Heading tag={"h2"} icon={<GiWatch />}>
            Aktuelle Highlights
          </Heading>
          <RandomShopItems />
          <Spacer />
          <Center>
            <Button
              sx={{ textDecoration: "none" }}
              colorScheme="brand"
              as={Link}
              to="/schaufenster"
            >
              Mehr Produkte entdecken
            </Button>
          </Center>
        </section>
        <Spacer />
        <section>
          <Heading tag={"h2"} icon={<GiShop />}>
            Out of Collection
          </Heading>
          <Box>
            <p>
              Entdecken Sie unsere „Out of Collection" – ausgewählte Uhren und
              Schmuckstücke zu besonderen Konditionen. In unserem Online-Shop
              finden Sie exklusive Einzelstücke und Modelle vergangener
              Kollektionen, die nur noch in begrenzter Stückzahl verfügbar sind.
            </p>
            <p>
              Sichern Sie sich Ihr persönliches Lieblingsstück, solange der
              Vorrat reicht.
            </p>
          </Box>
          <Spacer />
          <Center>
            <Button
              sx={{ textDecoration: "none" }}
              colorScheme="brand"
              as={Link}
              to="https://shop.juwelierhohage.de/"
            >
              Zum Out of Collection Shop
            </Button>
          </Center>
        </section>
        <Spacer />
        <CallToAction />
      </Wrapper>
    </>
  );
}

export default IndexPage;

export const query = graphql`
  query {
    laden: directusMediaCollection(name: {eq: "index"}) {
      name
      images: media {
        file {
          localFile {
            name
            childImageSharp {
              fluid(maxWidth: 800, maxHeight: 800, cropFocus: CENTER) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`;
